import { render, staticRenderFns } from "./ReservationPeriods.vue?vue&type=template&id=6bd4104d&scoped=true"
import script from "./ReservationPeriods.vue?vue&type=script&lang=js"
export * from "./ReservationPeriods.vue?vue&type=script&lang=js"
import style0 from "./ReservationPeriods.vue?vue&type=style&index=0&id=6bd4104d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd4104d",
  null
  
)

export default component.exports